module.exports = __webpack_public_path__ + "img/client-17.45ab5679.png";